import React, { PropsWithChildren } from 'react';
import { PerformanceFeatureFlagUtil } from 'utils/PerformanceFeatureFlagUtil';
import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/material/styles';

export const SkeletonCompat = (props: PropsWithChildren<typeof Skeleton.prototype.props>): JSX.Element => {
  const shouldAllowAnimations = PerformanceFeatureFlagUtil.shouldAllowSkeletonLoadingAnimation();
  return (
    <SkeletonContainer
      {...props}
      className={shouldAllowAnimations ? undefined : 'animationDisabled'}
      animation={shouldAllowAnimations ? undefined : false}
    >
      {props.children}
    </SkeletonContainer>
  );
};

const SkeletonContainer = styled(Skeleton)({
  '&.animationDisabled': {
    backgroundColor: 'var(--color_lvl_-4)',
  },
});
